/**
 * Focus trap utility.
 * Creates a focus trap within a container element, cycling Tab/Shift+Tab
 * through visible focusable elements.
 *
 * Usage:
 *   const trap = createFocusTrap(containerEl);
 *   trap.activate();   // start trapping
 *   trap.deactivate(); // stop trapping
 */

/* exported createFocusTrap */
/* eslint-disable no-unused-vars */

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

function createFocusTrap(container) {
  function getVisible() {
    return Array.from(container.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null && !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]');
    });
  }

  function handleKeydown(e) {
    if (e.key !== 'Tab') return;

    var focusable = getVisible();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  return {
    activate: function () {
      container.addEventListener('keydown', handleKeydown);
    },
    deactivate: function () {
      container.removeEventListener('keydown', handleKeydown);
    },
    focusFirst: function () {
      var focusable = getVisible();
      if (focusable.length > 0) focusable[0].focus();
    },
  };
}

window.createFocusTrap = createFocusTrap;
